import React from 'react';
import classNames from 'classnames';

const DEFAULT_SIZE = 20;

type IconProps = {
  name: string;
  size?: number;
} & React.HTMLProps<HTMLSpanElement>;

/**
 * Icon component. This component renders a named Material Symbols font, with an optional
 * size in pixels (e.g. 20 = 20px).
 *
 * ## Basic Usage
 *
 * ```tsx
 * import { Icon } from 'js/design_system/Icon';
 *
 * <Icon name="home" />
 * <Icon name="search" size={20} />
 * ```
 */
export const Icon = React.forwardRef<HTMLSpanElement, IconProps>(
  ({ name, size, className, style, ...spanProps }, ref) => (
    <span
      ref={ref}
      className={classNames(className, 'material-symbols-outlined')}
      style={{ ...style, fontSize: `${size ?? DEFAULT_SIZE}px` }}
      translate="no"
      {...spanProps}
    >
      {name}
    </span>
  ),
);
